export const cf7 = () => {
    $(function () {
        $('.js-re-cal').on('click', function() {
            window.location.href = '/cal?back=1'; 
        });
    });
}
